import gql from 'graphql-tag';
import { answerFieldsFragment } from './answerFieldsFragment';
import { evaluationFieldsFragment } from './evaluationFieldsFragment';
import { questionFieldsFragment } from './questionFieldsFragment';

export const scheduledSessionParticipantCorrectionEntryFieldsFragment = gql`
  fragment AdminScheduledSessionParticipantCorrectionEntryFields on ScheduledSessionParticipantCorrectionEntry {
    evaluation {
      _ref
    }
    question {
      _ref
    }
    stepIndex
    score
    comment
    answer {
      ...AdminAnswerFields
    }
    isSubmitted
  }

  ${evaluationFieldsFragment}
  ${questionFieldsFragment}
  ${answerFieldsFragment}
`;
